var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcStep1 = function SvgIcStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.35 9a.6.6 0 0 0-.933-.5l-1.5 1a.6.6 0 0 0 .666 1l.567-.379V15a.6.6 0 1 0 1.2 0V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-1.2 0a6.8 6.8 0 1 1-13.6 0 6.8 6.8 0 0 1 13.6 0Z"
  }))));
};
export default SvgIcStep1;